import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import addScrollbars from './util/addScrollbars';

ReactDOM.render(<App />, document.getElementById('root'));
addScrollbars();
registerServiceWorker();
